<template>
  <side-bar>
    <template slot="links">
      <sidebar-item
        :link="{
          name: userHasWebsite ? 'Dashboard' : 'Get Started',
          icon: userHasWebsite
            ? 'fas fa-th-large text-primary'
            : 'fas fa-check-double text-primary',
          path: userHasWebsite ? '/app/dashboard' : '/app/setup'
        }"
      ></sidebar-item>

      <!--
      <sidebar-item
        :link="{
          name: 'Monitoring',
          icon: 'fas fa-chart-line text-primary'
        }"
      >
        <sidebar-item :link="{ name: 'Components', path: '/settings' }" />
        <sidebar-item :link="{ name: 'Incidents', path: '/pricing' }" />
      </sidebar-item>
      -->

      <sidebar-item
        v-if="userHasWebsite"
        :link="{
          name: 'Settings',
          icon: 'fas fa-cogs text-primary'
        }"
      >
        <sidebar-item
          v-if="hasPremium"
          :link="{ name: 'Notifications', path: '/app/settings/notifications' }"
        />
        <sidebar-item
          :link="{ name: 'Status Page', path: '/app/settings/statuspage' }"
        />
      </sidebar-item>
      <sidebar-item
        :link="{
          name: 'Account',
          icon: 'fas fa-user-circle text-primary',
          path: '/'
        }"
      >
        <sidebar-item
          :link="{ name: 'Manage', path: '/app/settings/account' }"
        />
        <sidebar-item
          @click.native="logout"
          :link="{ name: 'Sign Out', path: '#home' }"
        />
      </sidebar-item>
    </template>

    <template slot="links-after">
      <hr class="my-3" />
      <h6 class="navbar-heading p-0 text-muted">Support</h6>

      <b-nav class="navbar-nav mb-md-3">
        <!--
        <b-nav-item
          href="https://www.creative-tim.com/learning-lab/bootstrap-vue/quick-start/argon-dashboard"
        >
          <i class="far fa-question-circle"></i>
          <b-nav-text class="p-0">Help Center</b-nav-text>
        </b-nav-item>
        -->
        <b-nav-item to="/pricing" v-if="!hasPremium">
          <i class="ni ni-spaceship"></i>
          <b-nav-text class="p-0">Upgrade Account</b-nav-text>
        </b-nav-item>
        <b-nav-item href="mailto:hello@boltscale.io">
          <i class="fas fa-envelope"></i>
          <b-nav-text class="p-0">Contact Us</b-nav-text>
        </b-nav-item>
      </b-nav>
    </template>
  </side-bar>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  name: "CustomSideBar",
  components: {},
  data: () => ({}),
  computed: {
    ...mapGetters("user", ["userHasWebsite", "hasPremium"])
  },
  methods: {
    logout() {
      console.log("LOGGING OUT!");
      const logout = this.$http.post("/logout").then((loggedOut) => {
        console.log(loggedOut);
        this.$router.push("/").catch((err) => {
          this.$router.go();
        });
      });
    }
  }
};
</script>
